'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dataKey = exports.dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/lib/util/eventConsts.js
// module id = 1751
// module chunks = 23